var __rspack_ns_object = JSON.parse('{"Primary":"أولي","Recent":"حديث","All":"الكل"}')